/**
 * Data: the records the workspace runs on, Intercom's grouping - the tag
 * vocabulary, the attribute schemas kept on people and conversations, the
 * imports that bring records in, and the contacts you have blocked.
 */
export default ({ t, accountScopedRoute, hasDataImport }) => ({
  name: 'Settings Data',
  label: t('SIDEBAR.SETTINGS_GROUP_DATA'),
  icon: 'i-ph-database',
  defaultFolded: true,
  children: [
    {
      name: 'Settings Tags',
      label: t('SIDEBAR.TAGS'),
      icon: 'i-ph-tag',
      to: accountScopedRoute('labels_list'),
    },
    {
      name: 'Settings People Attributes',
      label: t('SIDEBAR.PEOPLE_ATTRIBUTES'),
      icon: 'i-ph-identification-card',
      to: accountScopedRoute('customer_attributes_list'),
    },
    {
      name: 'Settings Conversation Attributes',
      label: t('SIDEBAR.CONVERSATION_ATTRIBUTES'),
      icon: 'i-ph-list-dashes',
      to: accountScopedRoute('attributes_list'),
    },
    ...(hasDataImport
      ? [
          {
            name: 'Settings Imports',
            label: t('SIDEBAR.IMPORTS'),
            icon: 'i-ph-download-simple',
            activeOn: ['settings_data_import_show'],
            to: accountScopedRoute('settings_data_imports'),
          },
        ]
      : []),
    {
      name: 'Settings Blocked Contacts',
      label: t('SIDEBAR.BLOCKED_CONTACTS'),
      icon: 'i-ph-prohibit',
      to: accountScopedRoute('blocked_contacts_list'),
    },
  ],
});
